export default {
  radii: [2, 4, 6, 8, 10, 14, 20, 999]
};
